import { useEffect, useState, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useRetryFetch from "../hooks/useRetryFetch";
import { useTranslation } from "react-i18next";
import { config } from "../Environment";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import "./PrescriptionList.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  solid /* regular */,
} from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used

import LoggerContext from "../context/LoggerProvider";

import { Skeleton } from "./ui/skeleton";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuItem,
  DropdownMenuContent,
} from "./ui/dropdown-menu";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";

const ActivitiesList = () => {
  const { auth } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { Logger } = useContext(LoggerContext);

  const retryFetch = useRetryFetch();

  const [prescriptions, setPrescriptions] = useState<any[]>([]);

  const viewPrescription = (idx: any, isMine: boolean) => {
    sessionStorage.setItem("prescriptionID", prescriptions[idx]._id);
    sessionStorage.removeItem("draftprescription");
    navigate("/readonly");
  };

  async function loadPrescriptions() {
    const response = await retryFetch(`${config.API_BASE}/api/prescriptions`);
    let presList = await response.json();
    setPrescriptions(presList);
  }

  useEffect(() => {
    loadPrescriptions();
  }, []);

  return (
    <div>
      <div
        className="preslist centercontainer w-auto md:w-1/2"
        style={{ width: "100%" }}
      >
        <Tabs defaultValue="activities">
          <TabsList>
            <TabsTrigger
              className="data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-sm"
              value="activities"
            >
              {t("activity_list")}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="activities">
            <div className="">
              <ul className="flex flex-row gap-6 my-3"></ul>
            </div>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>{t("name")}</TableHead>
                  <TableHead className="text-center">
                    {t("label_created_on")}
                  </TableHead>
                  <TableHead className="text-center">
                    {t("last_update")}
                  </TableHead>
                  <TableHead>&nbsp;</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {!!prescriptions
                  ? prescriptions.map((prescription: any, index: any) => {
                      return (
                        <TableRow key={index}>
                          <TableCell
                            className={
                              !prescription.valid ? "text-gray-300" : ""
                            }
                          >
                            {prescription.name}
                          </TableCell>
                          <TableCell className="text-center">
                            {prescription.createdOn}
                          </TableCell>
                          <TableCell className="text-center">
                            {prescription.lastUpdated}
                          </TableCell>
                          <TableCell className="equallySpaced">
                            <DropdownMenu>
                              <DropdownMenuTrigger className="bg-transparent ms-2">
                                <div className="w-[30px]">
                                  <FontAwesomeIcon
                                    title={t("actions")}
                                    style={{ paddingTop: "4px" }}
                                    icon={solid("ellipsis-vertical")}
                                  />
                                </div>
                              </DropdownMenuTrigger>
                              <DropdownMenuContent>
                                <DropdownMenuItem
                                  className="cursor-pointer"
                                  onClick={() => viewPrescription(index, true)}
                                >
                                  <div className="flex">
                                    <FontAwesomeIcon
                                      title={t("view")}
                                      icon={solid("eye")}
                                      className="ml-2 mr-2 mt-1 w-[15px]"
                                    />
                                    <span>{t("view")}</span>
                                  </div>
                                </DropdownMenuItem>
                              </DropdownMenuContent>
                            </DropdownMenu>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : Array(Math.floor(Math.random() * 10 + 5))
                      .join(".")
                      .split(".")
                      .map((_, arrIdx) => {
                        return (
                          <TableRow key={arrIdx}>
                            <TableCell>
                              <Skeleton className="h-[20px] w-[400px] rounded-xl bg-gray-200" />
                            </TableCell>
                            <TableCell>
                              <Skeleton className="h-[20px] w-[40px] rounded-xl bg-gray-200" />
                            </TableCell>
                            <TableCell>
                              <Skeleton className="h-[20px] w-[40px] rounded-xl bg-gray-200" />
                            </TableCell>
                          </TableRow>
                        );
                      })}
              </TableBody>
            </Table>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default ActivitiesList;
